import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FBF7EF', padding: 32 }}>
          <div style={{ maxWidth: 520, width: '100%', background: '#fff', border: '1px solid #E7E0D6', borderRadius: 16, padding: 32, textAlign: 'center' }}>
            <h1 style={{ fontSize: 24, fontWeight: 700, color: '#121316', marginBottom: 8 }}>Something went wrong</h1>
            <p style={{ color: '#5B616E', fontSize: 14, marginBottom: 16 }}>
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <pre style={{ background: '#F5F5F5', borderRadius: 8, padding: 12, fontSize: 12, color: '#B3261E', textAlign: 'left', overflow: 'auto', maxHeight: 200, marginBottom: 16 }}>
              {this.state.error?.toString()}
              {this.state.errorInfo?.componentStack?.slice(0, 500)}
            </pre>
            <button
              onClick={() => window.location.reload()}
              style={{ background: '#121316', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 24px', cursor: 'pointer', fontSize: 14 }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
